const assetsPaths = {
    logos: {
        brand: '/assets/logos/logo.svg',
    },
    placeholders: {
        avatar: '/assets/placeholders/avatar.webp',
        image: '/assets/placeholders/image.webp',
        product: '/assets/placeholders/product.png',
        brand: '/assets/placeholders/brand.png',
        compatibleCarsLogo: '/assets/placeholders/Hyundai.png',
        spark: '/assets/placeholders/spark plug 1.png',
        brandLogo: '/assets/placeholders/avatar.png',
        helpCenter: '/assets/placeholders/help-center.png',
        pdf: '/assets/placeholders/PDF-placeholder.png',
        xlsx: '/assets/placeholders/sheet-placeholder.png',
        emptyFormIllustration: '/assets/placeholders/empty-form-illustration.gif',
    },
    backgrounds: {
        login: '/assets/backgrounds/login_background.svg',
        register: '/assets/backgrounds/register_background.svg',
        companyInfo: '/assets/backgrounds/company_info_background.svg',
        RegisterVerification: '/assets/backgrounds/register_verification.svg',
        forgotPassword: '/assets/backgrounds/forgot_password_background.svg',
        verifyForgotPassword: '/assets/backgrounds/verify_forgot_password_background.svg',
        resetPassword: '/assets/backgrounds/reset_password_background.svg',
    },
    images: {
        fileUploader: '/assets/images/file_upload.svg',
        fileProcessing: '/assets/images/success_uploader.svg',
        workOrderFileUploader: '/assets/images/work_order_file_uploader.svg',
        order: '/assets/images/order.svg',
    },
    testImages: {
        image: '/assets/testImages/test.jpeg',
    },
};

export default assetsPaths;
